import "./About.css";
import aboutImg from "../assets/backgroundimage.webp"; // add your image here

export default function About() {
  return (
    <section id="about" className="about-section">

      <div className="about-container">

        {/* LEFT CONTENT */}
        <div className="about-content">
          <h2>ABOUT CASH FOR GOLD</h2>

          <h3>Bangalore's Trusted Gold Buyer</h3>

          <p>
            At Cash for Gold, we understand that life changes, and sometimes
            gold possessions you once cherished may no longer hold the same value.
            That’s why we’ve become Bangalore’s leading gold buyer, offering a
            reliable and transparent way to turn your unused gold into instant cash.
          </p>

          <a href="#contact" className="read-more">
            Read More →
          </a>
        </div>

        {/* RIGHT IMAGE */}
        <div className="about-image">
          <img src={aboutImg} alt="Cash for Gold" />
        </div>

      </div>

    </section>
  );
}